export function sortByKey(array: any[], key: string) {
  array.sort((a, b) => (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0));
}
